import { ActionTree, Commit, GetterTree, MutationTree } from 'vuex'
import masterApi from '../../api/masters'

export interface RootState {
    version: string;
}

export class states {
    id: string | undefined;
    name: string | undefined;
    code: string | undefined;
    abbreviation:string | undefined;
}
const state = Array<states>();
const getters: GetterTree<Array<states>, RootState> = {
    states(state: Array<states>) {
        return state
    }
};
export const mutations: MutationTree<Array<states>> = {
    LOAD_STATES(state: Array<states>, statess: Array<states>) {
        state.length=0;
        statess.forEach(element => {
            state.push(element)
        });
    },
    CLEAR_STATES(state: Array<states>) {
        state.length = 0
    }
};
const actions: ActionTree<Array<states>, RootState> = {
    async getStates({ state, commit }: { commit: Commit, state: Array<states> }): Promise<Array<states>> {
        if (state && state.length > 0) return state;
        try {
            const response = await masterApi.getStates()
            if (response && response.data && response.data.resultType === 200) {
                const data = response.data.payload;
                commit('LOAD_STATES', data)
                return state;
            }
            else {
                commit('CLEAR_STATES')
                return state;
            }
        }
        catch (error) {
            commit('CLEAR_STATES')
            return state;
        }
    }
}
export default {
    state,
    getters,
    mutations,
    actions
}